import request from '@/api/request'

export default {
  async getFlavors () {
    return (await request.get(`module/action/marketplace/netshoes/product_template/flavors`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/netshoes/product_template/sizes`)).data
  },
  async getColors () {
    return (await request.get(`module/action/marketplace/netshoes/product_template/colors`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/netshoes/product_template/brands`)).data
  },
  async getDepartments () {
    return (await request.get(`module/action/marketplace/netshoes/product/departments`)).data
  },
  async getProductTypes (departmentName) {
    return (await request.get(`module/action/marketplace/netshoes/product/product_types/${departmentName}`)).data
  },
  async getProductTemplateDepartments () {
    return (await request.get(`module/action/marketplace/netshoes/product_template/departments`)).data
  },
  async getProductTemplateProductTypes (businessId, departmentName) {
    return (await request.get(`module/action/marketplace/netshoes/product_template/product_types/${businessId}/${departmentName}`)).data
  },
  async getAttributes (businessId, departmentName, productTypeName) {
    return (await request.get(`module/action/marketplace/netshoes/product_template/attributes/${businessId}/${departmentName}/${productTypeName}`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/netshoes/index.js